import Vue from 'vue';
import Component from 'vue-class-component';
import ProductsList from '@/components/ProductsList/ProductsList.vue';
import { DTO } from '@extTypes/dto/productDto';

@Component({
    name: 'Products',
    components: {
        'products-list': ProductsList
    }
})
export default class Products extends Vue {
    onBackButton() {
        this.$router.push('/');
    }

    onProductSelect(data: { product: DTO.ShopifyProductList; store: string }) {
        // Go to the set selection page
        this.$router.push({
            path: '/product',
            query: {
                product: data.product.id.toString()
            }
        });
    }
}
